import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'component',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `component`,
    method: 'get',
    params: queriesParams
  })
}

export function addComponent(data) {
  return request({
    method: 'post',
    url: 'component',
    data
  })
}

export function show (id) {
  return request({
    url: `component/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `component/${id}`,
    method: 'patch',
    data
  })
}